<template>
  <div class="c-filter">
    <div class="c-form">
      <ElForm inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem label-width="0">
          <ElInput v-model.trim="keyword" placeholder="请输入任务名称或ID" style="width: 220px" @keyup.enter.native="sendEvent">
            <i slot="append" @click="sendEvent" class="el-icon-search"></i>
          </ElInput>
        </ElFormItem>
        <ElFormItem>
          <el-select v-model="status" multiple collapse-tags filterable placeholder="选择任务状态">
            <el-option v-for="label in stateData" :key="label.id" :value="label.id" :label="label.name"></el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem>
          <el-select v-model="opId" multiple collapse-tags filterable placeholder="选择提交人">
            <el-option v-for="label in operatorData" :key="label.id" :value="label.id" :label="label.name"></el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem>
          <el-select v-model="type" multiple collapse-tags filterable placeholder="选择任务类型">
            <el-option v-for="label in typeData" :key="label.id" :value="label.id" :label="label.name"></el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem class="bg-transparent">
          <ElButton type="primary" @click="sendEvent">查询</ElButton>
        </ElFormItem>
      </ElForm>
    </div>
  </div>
</template>
<script>
import { trim } from '@/common/js/utils'
export default {
  name: 'listFilter',
  props: {
    operatorData: {
      type: Array
    },
    stateData: {
      type: Array
    },
    typeData: {
      type: Array
    }
  },
  methods: {
    sendEvent() {
      const params = {
        keyword: trim(this.keyword),
        opIds: this.opId.length ? this.opId : undefined,
        imageTaskType: this.type.length ? this.type : undefined,
        imageTaskStatus: this.status.length ? this.status : undefined
      }
      this.$emit('on-change', params)
    }
  },
  data() {
    return {
      keyword: '',
      opId: [],
      status: [],
      type: []
    }
  },
  created() {
    this.sendEvent()
  }
}
</script>
